import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';

const drawerWidth = 240;

const useStyles = makeStyles({
  root: {
    position: "fixed",
    bottom: "0",
    // width: "100%",
    width: `calc(100% - ${drawerWidth}px)`,
    height: "80px",
    marginLeft: drawerWidth,
  },
});

export const SimpleBottomNavigation = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      showLabels
      className={classes.root}
    >
      <BottomNavigationAction icon={<SkipPreviousIcon style={{ fontSize: 40 }} />} />
      <BottomNavigationAction icon={<PlayCircleFilledIcon style={{ fontSize: 40 }} />} />
      <BottomNavigationAction icon={<SkipNextIcon style={{ fontSize: 40 }} />} />
    </BottomNavigation>
  );
}